



















































































import Vue from 'vue'
import SocialStreamConfigStore from '@/store/socialStream/socialStreamConfig'
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'
import { CatalogItem } from '@/store/socialStream/postApiRequestHelper'
import CatalogItemsLinkerStore from '@/store/catalogItemsLinker/catalogItemsLinker'
import PostsByRowList from '@/views/components/socialStream/PostsByRowList.vue'
import PostListManage from '@/views/components/socialStream/PostListManage.vue'

export default Vue.extend({
  components: {
    PostListManage, PostsByRowList,
  },
  data() {
    return {
      catalogId: 'not-set',
      sort: {
        field: 'id',
        order: 'asc',
      },
      query: '',
    }
  },
  computed: {
    config() {
      return SocialStreamConfigStore.state.data.socialStreamConfig
    },
    catalogs() {
      return SocialStreamConfigStore.state.data.socialStreamCatalogs
    },
    dataLoading() {
      return SocialStreamConfigStore.state.dataLoading
    },
  },
  watch: {
    dataLoading() {
      this.setProductsFromCatalogStore()
    },
  },
  mounted() {
    this.getData()
    this.setCatalogItemsLinker()
    if(!SocialStreamConfigStore.state.dataLoading){
      this.setProductsFromCatalogStore()
    }
  },
  methods: {
    setProductsFromCatalogStore() {
      ProductsFromCatalogStore.commit('setSortByDirection', 'desc')
      ProductsFromCatalogStore.commit('setCatalogId', SocialStreamConfigStore.state.data.socialStreamCatalogs.instagramPostsCatalogId)
    },
    getData() {
      SocialStreamConfigStore.dispatch('getSocialStreamConfig', this.$route.params.configId)      
    },
    goToConfigEdit(configId: string) {
      this.$router.push({ name: 'socialStreamConfig', params: { configId } })
    },
    goToCatalogs(configId: string) {
        this.$router.push({ name: 'socialStreamCatalogs', params: { configId } })
    },
    setCatalogItemsLinker() {
      CatalogItemsLinkerStore.commit('setContext', 'socialStream')
      CatalogItemsLinkerStore.commit('setInstanceId', this.$route.params.configId)
      CatalogItemsLinkerStore.dispatch('getAllLinkedIds')
    },
    hasPostsToDisplay() {
      return ProductsFromCatalogStore.state.productsList !== null
    },
    postsToDisplay() {
      return ProductsFromCatalogStore.state.productsList as Array<CatalogItem>
    },
  },
})
